import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useState } from "react";

export default function ConfirmationDialog({
                                               isOpen,
                                               message,
                                               handleClose,
                                               handleConfirm,
                                               title,
                                               showCancelButton = true
                                           }) {

    const [isClicked, setIsClicked] = useState(false)

    const handleOnClick = () => {
        handleConfirm(true)
        setIsClicked(true)
        setTimeout(() => {
                setIsClicked(false)
            }, 2000
        )
    }

    return (
        <div>
            <Dialog
                open={isOpen}
                onClose={handleClose}
                PaperProps={{
                    'data-testid': 'confirm-dialog'
                }}
            >
                <DialogTitle id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {message}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    {showCancelButton && <Button type="button" data-testid="confirm-close" onClick={() => {
                        handleConfirm(false);
                        if (handleClose) {
                            handleClose();
                        }
                    }}>Cancel</Button>}
                    <Button type="button" data-testid="confirm-execute" disabled={isClicked} onClick={handleOnClick} autoFocus>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
